import { useForm } from 'react-hook-form';
import { Box, Text, VStack } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import useInputAttributes from 'hooks/useInputAttributes';
import { useTranslation } from 'localization';

import { Button, Input } from 'components';
import { yup } from 'utils';

type PayloadType = {
  source_wallet: string;
  destination_identifier_number: number;
  amount: number;
};

const UserToBroker: React.FC = () => {
  const { t } = useTranslation('component.transfer');

  const schema = yup.object().shape({
    source_wallet: yup.string().label(t('form.source_wallet')).required(),
    destination_identifier_number: yup
      .number()
      .label(t('form.destination_identifier_number'))
      .required(),
    amount: yup.number().label(t('form.amount')).required(),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {},
  });

  /* eslint-disable no-unused-vars */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onSubmit = async (data: PayloadType) => {
    // API CALL
  };

  const formProps = useInputAttributes(register, errors, {
    source_wallet: t('form.source_wallet'),
    destination_identifier_number: t('form.destination_identifier_number'),
    amount: t('form.amount'),
  });

  return (
    <Box w="100%">
      <form onSubmit={handleSubmit(onSubmit)}>
        <VStack w={{ base: '100%', lg: '50%' }} align="flex-start" p={8}>
          <Box w="100%" mb={6}>
            <Input {...formProps.source_wallet} isSelectBox />
          </Box>
          <Text fontSize="2xl" fontWeight="500">
            {t('destinationAccount')}
          </Text>
          <Box w="100%" mb={6}>
            <Input {...formProps.destination_identifier_number} />
          </Box>
        </VStack>
        <Box bgColor="lightPrimary" p={4} textAlign="center">
          <Text color="warning">{t('hint')}</Text>
        </Box>
        <VStack w={{ base: '100%', lg: '50%' }} align="flex-start" p={8}>
          <Box w="100%" pos="relative">
            <Text
              fontSize="2xl"
              fontWeight="500"
              pos="absolute"
              top="35%"
              left={4}
              zIndex={9}
            >
              EUR
            </Text>
            <Text
              fontSize="2xl"
              fontWeight="500"
              pos="absolute"
              top="35%"
              right={4}
              zIndex={9}
            >
              $
            </Text>
            <Input
              {...formProps.amount}
              bgColor="lightPrimary"
              border="none"
              borderRadius="lg"
              py={10}
              pr={10}
              pl={20}
              textAlign="right"
              type="number"
              step="0.01"
              min="0"
              fontSize="2xl"
              fontWeight="500"
            />
          </Box>
          <Button
            type="submit"
            variant="filled"
            display="block"
            title={t('submit')}
            minW="100%"
            mt={{ base: 8, md: 8 }}
          />
        </VStack>
      </form>
    </Box>
  );
};

export default UserToBroker;
